export const isExpiredToken = (expired?: number): boolean => {
  if (expired) {
    const now = Math.round(Date.now() / 1000);
    const delayMs = expired - now;
    return !Boolean(delayMs <= 0);
  }
  return false;
};
